import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { FinalCausalityDataProps } from './props';
import { useFinalCausalityData } from './hook';
import Loading from '../../../../../components/general/loadings/loading';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const FinalCausalityData = ({
    finalCausality,
    loading,
}: FinalCausalityDataProps) => {
    const { formik } = useFinalCausalityData(finalCausality);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Causalidad final"
                    name="finalCausality"
                    size="small"
                    value={formik.values.finalCausality}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número causa"
                    name="causeNumber"
                    size="small"
                    value={formik.values.causeNumber}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Causa real"
                    name="realCause"
                    size="small"
                    rows={3}
                    value={formik.values.realCause}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Significado"
                    name="meaning"
                    size="small"
                    rows={3}
                    value={formik.values.meaning}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    rows={3}
                    value={formik.values.description}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    disabled
                />
            </Grid>
        </Grid>
    );
};
